export const HOME_VIDEOS="home videos";
export const LIKED_VIDEOS="Liked videos";
export const CONTINUE_WATCHING="Continue Watching";
export const FEATURED_VIDEOS="featured videos";
export const MOST_VIEWED_VIDEOS="most viewed videos";
export const ALL_VIDEOS="all videos";
export const VIDEOS="videos";
export const BLOGS="blogs";
export const PLAYLISTS="playlists";
